<template>
    <div class="join-us-question">
        <div class="form-group join-us-form-group">
            <label class="join-us-label" v-bind:class="{required: question.required}">{{ question.question }}</label>
            <div v-if="question.type === 'radio'" class="join-us-control">
                <div class="custom-control custom-radio custom-control-inline"
                     v-for="(option, option_index) in question.options">
                    <input type="radio" :value="option" :name="'question' + question.code"
                           :id="'question-' + question.code + '-' + option" class="custom-control-input input-value"
                           v-model="singleAnswer">
                    <label class="custom-control-label" :for="'question-' + question.code + '-' + option">{{ option
                        }}</label>
                </div>
            </div>

            <div v-if="question.type === 'checkbox'" class="join-us-control">
                <div class="custom-control custom-checkbox custom-control-inline"
                     v-for="(option, option_index) in question.options">
                    <input type="checkbox" :value="option" :name="'question' + question.code + '[]'"
                           :id="'question-' + question.code + '-' + option" class="custom-control-input input-value"
                           v-model="multipleOptions">
                    <label class="custom-control-label" :for="'question-' + question.code + '-' + option">{{ option
                        }}</label>
                </div>
            </div>

            <div v-if="question.type === 'text'" class="join-us-control">
                <input type="text" class="form-control" v-model="singleAnswer">
            </div>

            <div v-if="question.type === 'textarea'" class="join-us-control">
                <textarea type="text" rows="3" class="form-control" v-model="singleAnswer"></textarea>
            </div>

            <div v-if="question.type === 'number'" class="join-us-control">
                <input type="number" class="form-control" v-model="singleAnswer">
            </div>
        </div>
        <div v-if="question.children && question.children.length > 0">
            <join-us-question
                v-for="child_question in question.children"
                :question="child_question"
                v-on:question-answer="emitEvent"
                :key="child_question.code">
            </join-us-question>
        </div>
    </div>
</template>

<script>
    export default {
        name: "join-us-question",

        props: {
            'question': Object
        },

        data() {
            return {
                singleAnswer: "",
                multipleOptions: [],
            };
        },

        watch: {
            singleAnswer: function (answer) {
                this.emitEvent({
                    key: this.question.code,
                    value: answer
                });
            },

            multipleOptions: function (answer) {
                this.emitEvent({
                    key: this.question.code,
                    value: answer
                });
            }
        },

        methods: {
            emitEvent(payload) {
                this.$emit('question-answer', payload)
            }
        },
    }
</script>
